import { render, staticRenderFns } from "./addOldManFile.vue?vue&type=template&id=4030a060&scoped=true&"
import script from "./addOldManFile.vue?vue&type=script&lang=js&"
export * from "./addOldManFile.vue?vue&type=script&lang=js&"
import style0 from "./addOldManFile.vue?vue&type=style&index=0&id=4030a060&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030a060",
  null
  
)

export default component.exports